module.exports = __webpack_public_path__ + "608a9124ffdfd1aaf51877981dbbaac1.svg";